export default __webpack_public_path__ + "static/media/c002-eCommerce.f249fd36.png";